var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsAutomation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tabler:settings-automation"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.8214 18.2857C9.37857 18.2857 7.00357 17.0643 5.57857 14.8929H9.10714V13.5357H3.67857V18.9643H5.03571V16.4536C6.73214 18.4893 9.175 19.6429 11.8214 19.6429V18.2857ZM22 15.5714V14.2143H20.575C20.5071 13.8071 20.3036 13.4 20.1 12.9929L21.1179 11.975L20.1679 11.025L19.15 12.0429C18.8107 11.8393 18.4036 11.6357 17.9286 11.5679V10.1429H16.5714V11.5679C16.1643 11.6357 15.7571 11.8393 15.35 12.0429L14.3321 11.025L13.3821 11.975L14.4 12.9929C14.1964 13.3321 13.9929 13.7393 13.925 14.2143H12.5V15.5714H13.925C13.9929 15.9786 14.1964 16.3857 14.4 16.7929L13.3821 17.8107L14.3321 18.7607L15.35 17.7429C15.6893 17.9464 16.0964 18.15 16.5714 18.2179V19.6429H17.9286V18.2179C18.3357 18.15 18.7429 17.9464 19.15 17.7429L20.1679 18.7607L21.1179 17.8107L20.1 16.7929C20.3036 16.4536 20.5071 16.0464 20.575 15.5714H22ZM17.25 16.9286C16.0964 16.9286 15.2143 16.0464 15.2143 14.8929C15.2143 13.7393 16.0964 12.8571 17.25 12.8571C18.4036 12.8571 19.2857 13.7393 19.2857 14.8929C19.2857 16.0464 18.4036 16.9286 17.25 16.9286ZM14.5357 6.75H18.0643C15.825 3.28929 11.2107 2.33929 7.75 4.57857C5.64643 5.93571 4.35714 8.31071 4.35714 10.8214H3C3 5.93571 6.93571 2 11.8214 2C14.4679 2 16.9107 3.15357 18.6071 5.18929V2.67857H19.9643V8.10714H14.5357V6.75Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsAutomation);
export default __webpack_public_path__ + "static/media/settings-automation.d4f8fc5d277ddb1b80c646f752c36892.svg";
export { ForwardRef as ReactComponent };